import { programInfo } from '@trips/shared/valuations';
import s from './Wallet.module.css';

/**
 * What a redemption got against what the program's points are usually worth: "4.8¢" with
 * "typical 1.7¢, 2.9× more" (or "40% less") underneath.
 */
export function CppCompare({ cpp, programId }: { cpp: number; programId: string }) {
  const info = programInfo(programId);
  const typical = info?.typicalCpp ?? null;
  const ratio = typical ? cpp / typical : null;
  const diff =
    ratio == null
      ? null
      : ratio >= 1.1
        ? `${ratio >= 2 ? `${ratio.toFixed(1)}×` : `${Math.round((ratio - 1) * 100)}%`} more`
        : ratio <= 0.9
          ? `${Math.round((1 - ratio) * 100)}% less`
          : 'about typical';
  return (
    <span className={s.rowRight}>
      <span className={`${s.rowValue} ${info && cpp >= info.goodCpp ? s.good : ''} num`}>
        {cpp.toFixed(1)}¢
      </span>
      {typical != null && (
        <span className={`${s.rowDetail} num`}>
          typical {typical.toFixed(1)}¢, {diff}
        </span>
      )}
    </span>
  );
}
